export const PricingTypes = Object.freeze({
    PerOrder: 1,
    PerPerson: 2,
    PerGroup: 3
});


// WEBPACK FOOTER //
// ./src/enums/pricingType.js